import { EARTH_CIRCUMFERENCE_IN_METERS, METERS_PER_CSS_PIXEL } from "../constants";

/**
 * @name getScaleDenominator
 * @description Returns the N of the cartographic scale "1:N" at the map centre.
 *
 * At zoom z the world is `tileSize × 2^z` pixels wide, so
 *
 *   metersPerPixel   = circumferenceAtLat / (tileSize × 2^z)
 *   scaleDenominator = metersPerPixel / metersPerCssPixel
 *
 * Deliberately the closed form rather than measuring the viewport with `unproject`: it stays
 * invertible (the zoom buttons need to go the other way) and does not drift when the camera tilts.
 *
 * @see https://wiki.openstreetmap.org/wiki/Zoom_levels
 */
function getScaleDenominator({ zoom, latitude, tileSize }: { zoom: number; latitude: number; tileSize: number }): number {
	const latitudeRad = (latitude * Math.PI) / 180;
	const circumferenceAtLat = EARTH_CIRCUMFERENCE_IN_METERS * Math.cos(latitudeRad);
	const metersPerPixel = circumferenceAtLat / (tileSize * 2 ** zoom);

	return metersPerPixel / METERS_PER_CSS_PIXEL;
}

export { getScaleDenominator };
